/* Monroe & Leisure delivery estimate for standard rugs and framed artwork. */
if (!customElements.get('ml-delivery-estimate')) {
  customElements.define(
    'ml-delivery-estimate',
    class MlDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.form = document.getElementById(
          this.dataset.productFormId
        );
        this.heading = this.querySelector(
          '[data-ml-delivery-heading]'
        );
        this.orderDate = this.querySelector(
          '[data-ml-delivery-order-date]'
        );
        this.middleLabel = this.querySelector(
          '[data-ml-delivery-middle-label]'
        );
        this.middleDate = this.querySelector(
          '[data-ml-delivery-middle-date]'
        );
        this.finalLabel = this.querySelector(
          '[data-ml-delivery-final-label]'
        );
        this.finalDate = this.querySelector(
          '[data-ml-delivery-final-date]'
        );
        this.note = this.querySelector(
          '[data-ml-delivery-note]'
        );
        this.propertyInput = this.querySelector(
          '[data-ml-delivery-property]'
        );

        if (
          !this.form ||
          !this.heading ||
          !this.orderDate ||
          !this.middleLabel ||
          !this.middleDate ||
          !this.finalLabel ||
          !this.finalDate ||
          !this.note ||
          !this.propertyInput
        ) return;

        this.dataset.initialized = 'true';

        if (this.dataset.deliveryType === 'framed') {
          this.renderFramed();
        } else {
          this.renderStandard();
        }
      }

      getNumber(name, fallback) {
        const value = Number(this.dataset[name]);
        return Number.isFinite(value) ? value : fallback;
      }

      today() {
        const now = new Date();

        return new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          12
        );
      }

      addCalendarDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      }

      addWorkingDays(date, days) {
        const result = new Date(date);
        let added = 0;

        while (added < days) {
          result.setDate(result.getDate() + 1);

          /*
           * Standard production and delivery count
           * Monday through Saturday.
           */
          if (result.getDay() !== 0) {
            added += 1;
          }
        }

        return result;
      }

      formatDate(date) {
        const locale =
          document.documentElement.lang || 'en-US';

        return new Intl.DateTimeFormat(locale, {
          month: 'short',
          day: 'numeric'
        }).format(date);
      }

      formatRange(start, end) {
        const startText = this.formatDate(start);
        const endText = this.formatDate(end);

        if (
          start.getFullYear() === end.getFullYear() &&
          start.getMonth() === end.getMonth()
        ) {
          return `${startText}–${end.getDate()}`;
        }

        return `${startText}–${endText}`;
      }

      renderStandard() {
        const orderDate = this.today();

        const readyMin = this.getNumber(
          'standardReadyMin',
          7
        );
        const readyMax = this.getNumber(
          'standardReadyMax',
          8
        );
        const deliveryMin = this.getNumber(
          'standardDeliveryMin',
          9
        );
        const deliveryMax = this.getNumber(
          'standardDeliveryMax',
          10
        );

        const readyStart = this.addCalendarDays(
          orderDate,
          readyMin
        );
        const readyEnd = this.addCalendarDays(
          orderDate,
          readyMax
        );
        const deliveryStart = this.addWorkingDays(
          orderDate,
          deliveryMin
        );
        const deliveryEnd = this.addWorkingDays(
          orderDate,
          deliveryMax
        );

        const deliveryRange = this.formatRange(
          deliveryStart,
          deliveryEnd
        );

        this.heading.textContent = 'Standard-size rug';

        this.orderDate.textContent =
          `Today · ${this.formatDate(orderDate)}`;

        this.middleLabel.textContent = 'Order ready';

        this.middleDate.textContent = this.formatRange(
          readyStart,
          readyEnd
        );

        this.finalLabel.textContent =
          'Estimated delivery';

        this.finalDate.textContent = deliveryRange;

        this.note.textContent =
          'Delivery dates are estimates and may vary slightly in transit.';

        this.propertyInput.value =
          `Delivery expected ${deliveryRange}`;
      }

      renderFramed() {
        const orderDate = this.today();

        const shipDays = this.getNumber(
          'framedShipDays',
          21
        );

        const shipDate = this.addCalendarDays(
          orderDate,
          shipDays
        );

        const shipText = this.formatDate(shipDate);

        this.heading.textContent = 'Framed artwork';

        this.orderDate.textContent =
          `Today · ${this.formatDate(orderDate)}`;

        this.middleLabel.textContent = 'Made to order';
        this.middleDate.textContent = 'Up to 3 weeks';

        this.finalLabel.textContent = 'Expected to ship';
        this.finalDate.textContent = `By ${shipText}`;

        this.note.textContent =
          'Your framed artwork is made to order in our Pennsylvania studio.';

        this.propertyInput.value =
          `Framed artwork expected to ship by ${shipText}`;
      }
    }
  );
}